<template>
    <div>
        <div name="query-sort-block">
            <swb-goods-ship-voucher-search ref="query_model" @showSearch="searchMethod"></swb-goods-ship-voucher-search>
        </div>
        <div class="simple-row" v-if="checkActionPerm('to_ship') && ((currGoodsOrderId != null && !currCancelledFlag) || currGoodsOrderId == null)">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="toGoodsShipCreate()">{{currGoodsOrderId == null ? '新增发货单' : '发货'}}</button>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="goodsShipVoucherList" border style="width: 100%" :height="domHeight">
                <el-table-column prop="no" label="发货单号" width="180">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" v-if="checkActionPerm('view_detail')" @click="showShipInfoDlg(rows.row.id)">{{rows.row.no}}</a>
                        <span v-else>{{rows.row.no}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单号" width="180">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" v-if="checkActionPerm('to_order_list')" @click="toGoodsOrderInfo(rows.row.goodsOrder.id)">{{rows.row.orderNo}}</a>
                        <span v-else>{{rows.row.orderNo}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="buyerName" label="买家名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="buyerShopName" label="买家业务单元" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="buyerBizUnitName" label="买家所属部门" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="logisExpNo" label="物流单号" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="logisFee" label="物流费用(元)" width="120" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.logisFee != null">{{rows.row.logisFee.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="商品金额(元)" width="120" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.amount != null">{{rows.row.amount.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="confirmed" label="状态" width="100">
                    <template slot-scope="rows">
                        <div v-if="rows.row.invalid==0">
                            <div v-if="rows.row.receiveState==1">
                                <el-tag type="success" style="background-color: transparent; border: none" close-transition>已部分收货</el-tag>
                            </div>
                            <div v-if="rows.row.receiveState==2">
                                <el-tag type="success" style="background-color: transparent; border: none" close-transition>已全部收货</el-tag>
                            </div>
                            <div v-if="rows.row.receiveState==-1">
                                <el-tag type="success" style="background-color: transparent; border: none" close-transition>已拒收</el-tag>
                            </div>
                            <div v-if="rows.row.receiveState==0">
                                <el-tag type="success" style="background-color: transparent; border: none" v-if="rows.row.confirmed==true" close-transition>
                                    <span>已发货</span>
                                </el-tag>
                                <el-tag type="danger" style="background-color: transparent; border: none" v-if="rows.row.confirmed ==false" close-transition>
                                    <span>未发货</span>
                                </el-tag>
                            </div>
                        </div>
                        <div v-if="rows.row.invalid==1">
                            <el-tag type="danger" style="background-color: transparent; border: none" close-transition>已作废</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="confirmTime" label="发货确认时间" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="senderContactName" label="发货人" width="130" show-overflow-tooltip></el-table-column>
                <el-table-column prop="senderContactTel" label="发货人联系方式" width="130" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shipProxied" label="委托发货" width="80" align="center">
                    <template slot-scope="rows">
                        <span>{{rows.row.shipProxied ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="操作" width="180">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" v-if="checkActionPerm('confirm_ship') && !rows.row.confirmed && !rows.row.invalid && !rows.row.shipProxied" @click="toConfirmedShip(rows.row.id)">确认发货</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_detail')" @click="showShipInfoDlg(rows.row.id)">查看</a>
                        <a class="swb-btn-link" v-if="!rows.row.shipProxied && checkActionPerm('invalidate') && (rows.row.confirmed==false || rows.row.receiveState==-1) && rows.row.invalid == 0" @click="invalidShipInfoDlg(rows.row.id)">作废</a>
                        <a class="swb-btn-link" v-if="rows.row.shipProxied && checkActionPerm('invalidate') && rows.row.invalid == 0 && (rows.row.shipRspState == -1 || !rows.row.shipReqSent)" @click="invalidShipInfoDlg(rows.row.id)">作废</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('apply') && !rows.row.invalid && rows.row.shipProxied && !rows.row.shipReqSent" @click="doShipReqSent(rows.row.id)">委托请求</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
        </div>
    </div>
</template>

<script>

    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import goodsDelivApi from '../../api/goodsDeliv'

    import SwbGoodsShipVoucherAdd from './GoodsShipVoucherAdd';
    Routes.add(SwbGoodsShipVoucherAdd);
    import SwbShowGoodsOrder from './ShowGoodsOrder';
    Routes.add(SwbShowGoodsOrder);

    import SwbGoodsShipVoucherInfo from './GoodsShipVoucherInfo';
    Vue.regist(SwbGoodsShipVoucherInfo);

    import SwbGoodsShipVoucherSearch from './GoodsShipVoucherSearch';
    Vue.regist(SwbGoodsShipVoucherSearch);

    export default {
        name: 'swb-goods-ship-voucher-list',
        path: '/goods/ship/voucher/list',
        pathOld: '/servc/goods/ship/voucher/list',
        avlActions: 'to_ship|confirm_ship|view_detail|invalidate|to_order_list',
        avlActionNames: '查看、确认发货、作废',
        avlScopes: 'servicer',
        desc: '发货单列表',
        props: ['goodsOrderId', 'cancelledFlag', 'noSetheight', 'selfPath'],
        data: function () {
            return {
                domHeight: 'auto',
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                goodsShipVoucherList: [],
                buyerId: null,
                buyerName: null,
                no: null,
                buyerShopName: null,
                logisExpNo: null,
                searchShow: false,
                //
                currGoodsOrderId: null,
                currCancelledFlag: null,
            }
        },
        created: function () {
            this.currGoodsOrderId = !Utils.isNoB(this.goodsOrderId) ? parseInt(this.goodsOrderId) : null;
            this.currCancelledFlag = Utils.isTrue(this.cancelledFlag);
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getGoodsShipVoucherList();
        },
        mounted() {
            let self = this;
            if(!Utils.isTrue(self.noSetheight)) {
                //注册domSizeWatcher
                let thisEl = $(this.$el);
                $(this.$el).addClass("overflow-hidden");
                //
                let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
                domSizeWatcher.setBaseEl(thisEl);
                domSizeWatcher.setMainEl(thisEl.find('.table-layout'), function (width, height, theEl) {
                    //根据新主元素的内容大小，调整表格高度
                    self.domHeight = height;
                });
                domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .btn-toolbar, .pagination-layout'));
                domSizeWatcher.start(500);
            }
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            searchMethod: function (queryModel) {
                //
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getGoodsShipVoucherList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                let path = Utils.isNoB(this.selfPath) ? Vue.$getClassInfo(this).path : this.selfPath;
                return checkUserActionPerm(path, action, targetPostId);
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getGoodsShipVoucherList();
            },
            // 发货单列表
            getGoodsShipVoucherList: function () {
                let self = this;
                let orderId = self.currGoodsOrderId;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };

                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let state = filterItems.state;
                if(!Utils.isNoB(state)) {
                    if(state == 'partRecv') {
                        filterItems.invalid = 0;
                        filterItems.receiveState = 1;
                    } else if(state == 'allRecv') {
                        filterItems.invalid = 0;
                        filterItems.receiveState = 2;
                    } else if(state == 'refusedRecv') {
                        filterItems.invalid = 0;
                        filterItems.receiveState = -1;
                    } else if(state == 'shiped') {
                        filterItems.invalid = 0;
                        filterItems.confirmed = true;
                        filterItems.receiveState = 0;
                    } else if(state == 'toShip') {
                        filterItems.invalid = 0;
                        filterItems.confirmed = false;
                        filterItems.receiveState = 0;
                    } else if(state == 'invalid') {
                        filterItems.invalid = 1;
                    }
                }
                if(!Utils.isNoB(orderId)) {
                    filterItems.orderId = orderId;
                }
                filterItems.ioFlag = 1;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsShipVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let data = result.data;
                        self.goodsShipVoucherList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 发货单信息
            showShipInfoDlg: function (id) {
                Vue.$showDialog({
                    title: '发货单信息',
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: -400,
                    height: 900,
                    template: '<swb-goods-ship-voucher-info :id="id" ref="swb_goods_ship_voucher_info"></swb-goods-ship-voucher-info>',
                    data: {
                        id: id
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {}
                })
            },
            toConfirmedShip(id){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '发货单 - 确认发货',
                    width: -400,
                    height: -400,
                    template: '<div>' +
                    '<swb-goods-ship-voucher-info :id="id" :type="type" ref="swb_goods_ship_voucher_info"></swb-goods-ship-voucher-info>' +
                    '</div>',
                    data: {
                        id: id,
                        type: 'confirmedShip'
                    },
                    methods: {},
                    okClicked: function () {
                        let warehouseId = this.$refs.swb_goods_ship_voucher_info.warehouseId;
                        let stockQuantityFlag = this.$refs.swb_goods_ship_voucher_info.stockQuantityFlag;
                        if(!Utils.isNoB(warehouseId)) {
                            if(!stockQuantityFlag) {
                                MsgBox.warning("仓库中没有部分商品信息");
                                return false;
                            }
                            self.$confirm('是否确定发货 ?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                let postData = {};
                                postData.id = id;
                                postData.warehouseId = warehouseId;
                                //
                                let msgBoxDlg = MsgBox.loading();
                                goodsDelivApi.confirmGoodsShipVoucher(postData, function (result) {
                                    msgBoxDlg.close();
                                    if(result.type == 'info') {
                                        MsgBox.success('成功');
                                        theDlg.close();
                                        self.getGoodsShipVoucherList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }).catch(function () {

                            });
                        } else {
                            MsgBox.warning("请选择出库仓库");
                        }
                        return false;
                    },
                    lifecycle: {}
                })
            },
            // 确认发货
            confirmedShip: function (id) {
                let self = this;
                this.$confirm('是否确定发货 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsDelivApi.confirmGoodsShipVoucher(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type == 'info') {
                            MsgBox.success('成功');
                            self.getGoodsShipVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },

            //作废
            invalidShipInfoDlg: function (id) {
                let self = this;
                this.$confirm('是否确定作废 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(({value}) => {
                    let postData = {};
                    postData.id = id;
                    postData.invalidCause = value;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsDelivApi.invalidGoodsShipVoucher(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type == 'info') {
                            MsgBox.success('成功');
                            self.getGoodsShipVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            toGoodsShipCreate: function () {
                let self = this;
                self.$router.push({
                    path: SwbGoodsShipVoucherAdd.path,
                    query: {
                        orderId: self.currGoodsOrderId
                    }
                })
            },
            // 跳转商品定单详情
            toGoodsOrderInfo: function (goodsOrderId) {
                this.$router.push({
                    path: SwbShowGoodsOrder.path,
                    query: {
                        goodsOrderId: goodsOrderId
                    }
                });
            },
            doShipReqSent(id){
                let self = this;
                //弹出确认框
                this.$confirm('确认发送委托请求吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoading = MsgBox.loading();
                    goodsDelivApi.doGoodsShipVoucherReqSend(id, function (result) {
                        theLoading.close();
                        if(result.type == "info") {
                            MsgBox.success('委托请求成功');
                            self.getGoodsShipVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsShipVoucherList.vue